namespace Portico.Services.Gateway {
    import Inject = Portico.Decorators.Inject;
    import Service = Portico.Decorators.Service;

    const apiModule = angular
        .module('app')
        .service('ApiGatewayConfiguration', [
            'serverConstants',
            'storageService',
            'webServiceUrls',
            (
                serverConstants: Portico.Models.Interfaces.IServerConstants,
                storageService: Portico.Services.StorageService,
                webServiceUrls: Portico.Models.Interfaces.IWebServiceUrls
            ) => {
                let container = new VueDI.Container();

                trialcard_apigateway.configure(
                    container,
                    <'qa' | 'uat' | 'training' | 'lab' | 'prod'>webServiceUrls.gateway.url
                );

                container.registerSingleton(trialcard_authentication.OAUTH_TOKEN_PROVIDER, {
                    get(container) {
                        return {
                            async getToken(context) {
                                const tokenName = `${Portico.Models.JWT_STORAGE_KEY}-${serverConstants.portalId}`;
                                return storageService.getItem<string>(
                                    Portico.Models.StorageType.Session,
                                    tokenName
                                );
                            },
                        };
                    },
                });

                container.registerInstance<import('axios').AxiosRequestConfig>(
                    trialcard_shared.AXIOS_CONFIGURATION,
                    {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        transformRequest(data: any, headers?: any) {
                            delete headers['User-Agent'];
                            if (Array.isArray(axios.default.defaults.transformRequest)) {
                                return axios.default.defaults.transformRequest[0](data, headers);
                            }
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            return axios.default.defaults.transformRequest!(data, headers);
                        },
                    }
                );

                window;

                container.registerInstance<string>(trialcard_shared.X_TC_USERID, '');

                return container;
            },
        ])
        .service('CardExtV1Api', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.CardExtV1Api),
        ])
        .service('CaseV3Api', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.CaseV3Api),
        ])
        .service('ClaimV1Api', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.ClaimV1Api),
        ])
        .service('DiagnosisV3Api', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.DiagnosisV3Api),
        ])
        .service('DocumentV3Api', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.DocumentV3Api),
        ])
        .service('EdgeApi', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.EdgeApi),
        ])
        .service('EdgeAccountApi', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.EdgeAccountApi),
        ])
        .service('EdgeAdminApi', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.EdgeAdminApi),
        ])
        .service('EdgeAuthenticationApi', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.EdgeAuthenticationApi),
        ])
        .service('EdgeClaimApi', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.EdgeClaimApi),
        ])
        .service('EdgeCouponApi', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.EdgeCouponApi),
        ])
        .service('EdgeDebitCardApi', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.EdgeDebitCardApi),
        ])
        .service('EdgeDocumentsApi', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.EdgeDocumentsApi),
        ])
        .service('EdgeEmailApi', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.EdgeEmailApi),
        ])
        .service('EdgeEnrollmentApi', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.EdgeEnrollmentApi),
        ])
        .service('EdgeHubApi', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.EdgeHubApi),
        ])
        .service('EdgeIntakeApi', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.EdgeIntakeApi),
        ])
        .service('EdgeMangoApi', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.EdgeMangoApi),
        ])
        .service('EdgePatientAccountApi', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.EdgePatientAccountApi),
        ])
        .service('EdgePatientEnrollmentApi', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.EdgePatientEnrollmentApi),
        ])
        .service('EdgePayloadStagingApi', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.EdgePayloadStagingApi),
        ])
        .service('EdgePlpApi', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.EdgePlpApi),
        ])
        .service('EdgeSiteAccountApi', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.EdgeSiteAccountApi),
        ])
        .service('EdgeTempApi', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.EdgeTempApi),
        ])
        .service('EdgeTokenApi', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.EdgeTokenApi),
        ])
        .service('EmailV1Api', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.EmailV1Api),
        ])
        .service('EnrollmentExtV2Api', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.EnrollmentExtV2Api),
        ])
        .service('EnrollmentV1Api', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.EnrollmentV1Api),
        ])
        .service('EscoordV1Api', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.EscoordV1Api),
        ])
        .service('IntakeV1Api', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.IntakeV1Api),
        ])
        .service('LocationV1Api', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.LocationV1Api),
        ])
        .service('NotesV2Api', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.NotesV2Api),
        ])
        .service('PatientV3Api', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.PatientV3Api),
        ])
        .service('PayorV4Api', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.PayorV4Api),
        ])
        .service('PayorV4GlobalApi', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.PayorV4GlobalApi),
        ])
        .service('PharmacyV2Api', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.PharmacyV2Api),
        ])
        .service('PharmacyV2GlobalApi', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.PharmacyV2GlobalApi),
        ])
        .service('PrescriberV3Api', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.PrescriberV3Api),
        ])
        .service('PrescriptionV1Api', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.PrescriptionV1Api),
        ])
        .service('ProgramV2Api', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.ProgramV2Api),
        ])
        .service('SiteV2Api', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.SiteV2Api),
        ])
        .service('SiteV3Api', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.SiteV3Api),
        ])
        .service('SurveyV2Api', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.SurveyV2Api),
        ])
        .service('SurveyV3Api', [
            'ApiGatewayConfiguration',
            (container: InstanceType<VueDI['Container']>) =>
                container.get(trialcard_apigateway.SurveyV3Api),
        ]);

    export interface IGatewayService {
        CardExtV1: import('@trialcard/apigateway.client').CardExtV1Api;
        CaseV3: import('@trialcard/apigateway.client').CaseV3Api;
        ClaimV1: import('@trialcard/apigateway.client').ClaimV1Api;
        DiagnosisV3: import('@trialcard/apigateway.client').DiagnosisV3Api;
        DocumentV3: import('@trialcard/apigateway.client').DocumentV3Api;
        Edge: import('@trialcard/apigateway.client').EdgeApi;
        EdgeAccount: import('@trialcard/apigateway.client').EdgeAccountApi;
        EdgeAdmin: import('@trialcard/apigateway.client').EdgeAdminApi;
        EdgeAuthentication: import('@trialcard/apigateway.client').EdgeAuthenticationApi;
        EdgeClaim: import('@trialcard/apigateway.client').EdgeClaimApi;
        EdgeCoupon: import('@trialcard/apigateway.client').EdgeCouponApi;
        EdgeDebitCard: import('@trialcard/apigateway.client').EdgeDebitCardApi;
        EdgeDocuments: import('@trialcard/apigateway.client').EdgeDocumentsApi;
        EdgeEmail: import('@trialcard/apigateway.client').EdgeEmailApi;
        EdgeEnrollment: import('@trialcard/apigateway.client').EdgeEnrollmentApi;
        EdgeHub: import('@trialcard/apigateway.client').EdgeHubApi;
        EdgeIntake: import('@trialcard/apigateway.client').EdgeIntakeApi;
        EdgeMango: import('@trialcard/apigateway.client').EdgeMangoApi;
        EdgePatientAccount: import('@trialcard/apigateway.client').EdgePatientAccountApi;
        EdgePatientEnrollment: import('@trialcard/apigateway.client').EdgePatientEnrollmentApi;
        EdgePayloadStaging: import('@trialcard/apigateway.client').EdgePayloadStagingApi;
        EdgePlp: import('@trialcard/apigateway.client').EdgePlpApi;
        EdgeSiteAccount: import('@trialcard/apigateway.client').EdgeSiteAccountApi;
        EdgeTemp: import('@trialcard/apigateway.client').EdgeTempApi;
        EdgeToken: import('@trialcard/apigateway.client').EdgeTokenApi;
        EmailV1: import('@trialcard/apigateway.client').EmailV1Api;
        EnrollmentExtV2: import('@trialcard/apigateway.client').EnrollmentExtV2Api;
        EnrollmentV1: import('@trialcard/apigateway.client').EnrollmentV1Api;
        EscoordV1: import('@trialcard/apigateway.client').EscoordV1Api;
        IntakeV1: import('@trialcard/apigateway.client').IntakeV1Api;
        LocationV1: import('@trialcard/apigateway.client').LocationV1Api;
        NotesV2: import('@trialcard/apigateway.client').NotesV2Api;
        PatientV3: import('@trialcard/apigateway.client').PatientV3Api;
        PayorV4: import('@trialcard/apigateway.client').PayorV4Api;
        PayorV4Global: import('@trialcard/apigateway.client').PayorV4GlobalApi;
        PharmacyV2: import('@trialcard/apigateway.client').PharmacyV2Api;
        PharmacyV2Global: import('@trialcard/apigateway.client').PharmacyV2GlobalApi;
        PrescriberV3: import('@trialcard/apigateway.client').PrescriberV3Api;
        PrescriptionV1: import('@trialcard/apigateway.client').PrescriptionV1Api;
        ProgramV2: import('@trialcard/apigateway.client').ProgramV2Api;
        SiteV2: import('@trialcard/apigateway.client').SiteV2Api;
        SiteV3: import('@trialcard/apigateway.client').SiteV3Api;
        SurveyV2: import('@trialcard/apigateway.client').SurveyV2Api;
        SurveyV3: import('@trialcard/apigateway.client').SurveyV3Api;
    }

    @Service('app', 'gatewayService')
    @Inject(
        'CardExtV1Api',
        'CaseV3Api',
        'ClaimV1Api',
        'DiagnosisV3Api',
        'DocumentV3Api',
        'EdgeApi',
        'EdgeAccountApi',
        'EdgeAdminApi',
        'EdgeAuthenticationApi',
        'EdgeClaimApi',
        'EdgeCouponApi',
        'EdgeDebitCardApi',
        'EdgeDocumentsApi',
        'EdgeEmailApi',
        'EdgeEnrollmentApi',
        'EdgeHubApi',
        'EdgeIntakeApi',
        'EdgeMangoApi',
        'EdgePatientAccountApi',
        'EdgePatientEnrollmentApi',
        'EdgePayloadStagingApi',
        'EdgePlpApi',
        'EdgeSiteAccountApi',
        'EdgeTempApi',
        'EdgeTokenApi',
        'EmailV1Api',
        'EnrollmentExtV2Api',
        'EnrollmentV1Api',
        'EscoordV1Api',
        'IntakeV1Api',
        'LocationV1Api',
        'NotesV2Api',
        'PatientV3Api',
        'PayorV4Api',
        'PayorV4GlobalApi',
        'PharmacyV2Api',
        'PharmacyV2GlobalApi',
        'PrescriberV3Api',
        'PrescriptionV1Api',
        'ProgramV2Api',
        'SiteV2Api',
        'SiteV3Api',
        'SurveyV2Api',
        'SurveyV3Api'
    )
    export class GatewayService implements IGatewayService {
        constructor(
            public CardExtV1: import('@trialcard/apigateway.client').CardExtV1Api,
            public CaseV3: import('@trialcard/apigateway.client').CaseV3Api,
            public ClaimV1: import('@trialcard/apigateway.client').ClaimV1Api,
            public DiagnosisV3: import('@trialcard/apigateway.client').DiagnosisV3Api,
            public DocumentV3: import('@trialcard/apigateway.client').DocumentV3Api,
            public Edge: import('@trialcard/apigateway.client').EdgeApi,
            public EdgeAccount: import('@trialcard/apigateway.client').EdgeAccountApi,
            public EdgeAdmin: import('@trialcard/apigateway.client').EdgeAdminApi,
            public EdgeAuthentication: import('@trialcard/apigateway.client').EdgeAuthenticationApi,
            public EdgeClaim: import('@trialcard/apigateway.client').EdgeClaimApi,
            public EdgeCoupon: import('@trialcard/apigateway.client').EdgeCouponApi,
            public EdgeDebitCard: import('@trialcard/apigateway.client').EdgeDebitCardApi,
            public EdgeDocuments: import('@trialcard/apigateway.client').EdgeDocumentsApi,
            public EdgeEmail: import('@trialcard/apigateway.client').EdgeEmailApi,
            public EdgeEnrollment: import('@trialcard/apigateway.client').EdgeEnrollmentApi,
            public EdgeHub: import('@trialcard/apigateway.client').EdgeHubApi,
            public EdgeIntake: import('@trialcard/apigateway.client').EdgeIntakeApi,
            public EdgeMango: import('@trialcard/apigateway.client').EdgeMangoApi,
            public EdgePatientAccount: import('@trialcard/apigateway.client').EdgePatientAccountApi,
            public EdgePatientEnrollment: import('@trialcard/apigateway.client').EdgePatientEnrollmentApi,
            public EdgePayloadStaging: import('@trialcard/apigateway.client').EdgePayloadStagingApi,
            public EdgePlp: import('@trialcard/apigateway.client').EdgePlpApi,
            public EdgeSiteAccount: import('@trialcard/apigateway.client').EdgeSiteAccountApi,
            public EdgeTemp: import('@trialcard/apigateway.client').EdgeTempApi,
            public EdgeToken: import('@trialcard/apigateway.client').EdgeTokenApi,
            public EmailV1: import('@trialcard/apigateway.client').EmailV1Api,
            public EnrollmentExtV2: import('@trialcard/apigateway.client').EnrollmentExtV2Api,
            public EnrollmentV1: import('@trialcard/apigateway.client').EnrollmentV1Api,
            public EscoordV1: import('@trialcard/apigateway.client').EscoordV1Api,
            public IntakeV1: import('@trialcard/apigateway.client').IntakeV1Api,
            public LocationV1: import('@trialcard/apigateway.client').LocationV1Api,
            public NotesV2: import('@trialcard/apigateway.client').NotesV2Api,
            public PatientV3: import('@trialcard/apigateway.client').PatientV3Api,
            public PayorV4: import('@trialcard/apigateway.client').PayorV4Api,
            public PayorV4Global: import('@trialcard/apigateway.client').PayorV4GlobalApi,
            public PharmacyV2: import('@trialcard/apigateway.client').PharmacyV2Api,
            public PharmacyV2Global: import('@trialcard/apigateway.client').PharmacyV2GlobalApi,
            public PrescriberV3: import('@trialcard/apigateway.client').PrescriberV3Api,
            public PrescriptionV1: import('@trialcard/apigateway.client').PrescriptionV1Api,
            public ProgramV2: import('@trialcard/apigateway.client').ProgramV2Api,
            public SiteV2: import('@trialcard/apigateway.client').SiteV2Api,
            public SiteV3: import('@trialcard/apigateway.client').SiteV3Api,
            public SurveyV2: import('@trialcard/apigateway.client').SurveyV2Api,
            public SurveyV3: import('@trialcard/apigateway.client').SurveyV3Api
        ) {}
    }
}
